import { Table } from 'components/core-v2'

import { ApiAssetPriceWithHistory } from '@/api'
import { formatToDateTimeDisplay } from '@/utilities/date'

import { COLUMN_DEFS, DEFAULT_COLUMN_OPTIONS } from './columns'

export interface MarketDataTableProps {
  data: ApiAssetPriceWithHistory[]
  onShowPriceOverride: (selectedRow: any) => void
}

const MarketDataTable = ({ data, onShowPriceOverride }: MarketDataTableProps) => {
  const rowData = data.map(row => ({
    ...row,
    name: row.assetName,
    id: row.isinCode,
    assetId: row.isinCode,
    latestPriceData: formatToDateTimeDisplay(row.currentPrice?.receivedDateTime)
  }))
  return (
    <Table
      agGridProps={{
        columnDefs: COLUMN_DEFS,
        defaultColDef: DEFAULT_COLUMN_OPTIONS,
        headerHeight: 60,
        rowData,
        rowHeight: 44,
        context: { onShowPriceOverride }
      }}
      height="600px"
    />
  )
}

export default MarketDataTable
